import { Button, Input, Form, Space, message, Spin } from "antd";
import {sendResetPswdEmail, checkPasswordResetCode} from '../../requests/user';
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import './SetPassword.scss';
import Loading from "../../components/Loading/Loading";


function ResetPassword(props) {

    const navigate = useNavigate();
    const [email, setEmail] = useState(null);
    const [hasSendEmail, setHasSendEmail] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onFinish = async (values) => {
        // console.log('Success:', values);
        const res = await checkPasswordResetCode(values);
        if(res.result === 'success'){
            navigate('/set-password', {
                state: {
                    user_id: res.user_id,
                    token: res.token,
                    reset_id: res.reset_id
                }
            })
        }else{
            messageApi.error('Code not match');
        }
    };
    const onFinishFailed = (errorInfo) => {
        // messageApi.error('Send reset code error');
    };

    const handleSendEmail = async ()=>{
        setSpinning(true);
        const res = await sendResetPswdEmail(email);
        setSpinning(false);
        if(res === 'success'){
            setHasSendEmail(true);
        }else{
            messageApi.error('Send reset code error');
        }
    }

    return (
        <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '100vh' }}>
            {contextHolder}
            <Spin spinning={spinning} fullscreen tip='Sending...'/>
            <div className="reset-container">
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    style={{
                        maxWidth: 600,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >   
                <div style={{marginBottom: '30px'}}>
                    <h2 style={{fontWeight: 'bold'}}>Reset your password</h2>
                    <br/>
                    <span style={{fontSize: '1rem'}}>If the account exists, we'll email you the code to reset the password.</span>
                </div>
                    <Form.Item name={'email'} label="Email" rules={[{ type: 'email' }]}>
                        <Space.Compact style={{ width: '100%' }}>
                            <Input value={email} onChange={handleEmailChange}/>
                            <Button type="primary" onClick={handleSendEmail} disabled={hasSendEmail}>Send</Button>
                        </Space.Compact>                    
                    </Form.Item>
                    {hasSendEmail ? <Form.Item
                        label="Code"
                        name="code"
                        rules={[
                            {
                                message: 'Please input your code!',
                            },
                        ]}
                    >
                        <Input maxLength={6}/>
                    </Form.Item> : null}
                    <Form.Item
                        wrapperCol={{
                            span: 24,
                        }}
                    >
                        <Button type="primary" htmlType="submit" style={{width: '100%'}} disabled={!hasSendEmail}>
                            Reset password
                        </Button>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 0,
                            span: 24,
                        }}
                    >
                        <div className="d-flex justify-content-center">
                            <a href='/login'>return to login</a>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}

export default ResetPassword